export const getManagers = state => state.managers.managers;
export const getSelectedManagerFilters = state => state.managers.filters;
